var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step_item"},_vm._l((20),function(item,index){return _c('div',{key:index,staticClass:"item_tag"},[_c('Tag',{attrs:{"title":"Attributes","size":"big"}},[_vm._v(_vm._s(index + 1)+" %")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }